/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-25 14:05:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Link, Icon } from '@shopify/polaris';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import imageBanner from 'src/assets/images/banners/subscription-info-banner.svg';
import { URL } from 'src/constants/links';
import { ExternalMinor } from '@shopify/polaris-icons';

type State = {
  activeInfoBanner: boolean
};

class DidYouKnow extends Component<WithI18nProps, State> {
  state = { dismissedBanner: false };

  componentDidMount() {
    const dismissedBanner = this.getDismissedBanner();
    this.setState({
      dismissedBanner // Show information banner
    });
  }

  render() {
    const { dismissedBanner } = this.state;
    const { i18n } = this.props;

    return !dismissedBanner ? (
      <Banner
        name="DidYouKnowBannerExceeded"
        title={i18n.translate('AdminHTML.SubscriptionV4.DidYouKnow.title')}
        titleIcon="book"
        status="info"
        image={imageBanner}
        allowDismiss={true}
        onDismiss={this.handleDismissBanner}>
        <div className="did-you-know">
          <p>{i18n.translate('AdminHTML.SubscriptionV4.DidYouKnow.content1')}</p>
          <p>
            {i18n.translate('AdminHTML.SubscriptionV4.DidYouKnow.content2', {
              t1: (
                <span className="img-new-tab">
                  <Link url={URL.SubscriptionPlanDoc} external>
                    {i18n.translate('AdminHTML.SubscriptionV4.DidYouKnow.content_t1')}
                    <Icon source={ExternalMinor} color="interactive" />
                  </Link>
                </span>
              )
            })}
          </p>
        </div>
      </Banner>
    ) : (
      <></>
    );
  }

  // Get dismissed banner status
  getDismissedBanner = () => {
    const shop = getShop();
    try {
      const dismissedInStorage = localStorage.getItem(`${shop}-dismissBannerInSubscriptionPage`);
      if (dismissedInStorage === 'true') {
        return true;
      }
    } catch (error) {}

    return false;
  };
  // Handle hide banner
  handleDismissBanner = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissBannerInSubscriptionPage`, 'true');
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(DidYouKnow);
